import { AssetType, CmsProperty, FocusType, focusTypeFromProperties, StreamType } from '../../api/models/Shared.types';
import { CardDataSource } from './CardDataSource';
import { IRibbon2Detail, IRibbon2Schedule } from '../../api/models/AndromeTV.types';
import { ChannelModel } from '../../api/EpgApi.types';

export class ScheduleExtractor {
  private dataSource: CardDataSource;
  private focus: FocusType;
  private distance: number;
  channel: ChannelModel | undefined;
  schedule: IRibbon2Schedule | undefined;
  detail: IRibbon2Detail | undefined;
  constructor(dataSource: CardDataSource) {
    this.dataSource = dataSource;
    this.focus = focusTypeFromProperties(dataSource.pageProperties);
    this.distance = Number.MAX_VALUE;
    this.extract();
  }

  extract() {
    this.findSchedule(true);
    if (this.schedule === undefined && this.channel === undefined) {
      this.findSchedule(false);
    }
    this.detail = this._findDetail();
  }

  findSchedule(checkRights: boolean) {
    const now = new Date().getTime() / 1000;
    // console.log('findSchedule', now, this.dataSource.asset.asset.title);
    this.dataSource.asset.channels?.forEach(ribbonChannel => {
      const epgChannel = this.dataSource.channels.find(ch => ch.channelId === ribbonChannel.id);
      if (epgChannel && this._hasRights(epgChannel, checkRights)) {
        ribbonChannel.schedules?.forEach(schedule => {
          const dist = this._distanceFrom(now, schedule);
          if (Math.min(dist, this.distance) === dist) {
            this.distance = dist;
            this.schedule = schedule;
            this.channel = epgChannel;
          }
        });
      }
    });
  }

  _hasRights(epgChannel: ChannelModel, checkRights: boolean): boolean {
    if (!checkRights) {
      return true;
    }
    if (!epgChannel) {
      return false;
    }
    return this.focus === FocusType.PAST
      ? epgChannel.customerHasRight(StreamType.REPLAY)
      : epgChannel.customerHasRight(StreamType.LINEAR);
  }

  _distanceFrom(time: number, schedule: IRibbon2Schedule): number {
    const start = +schedule.published.start;
    const end = +schedule.published.end;

    if (this.focus === FocusType.PAST) {
      return end < time ? time - end : Number.MAX_VALUE;
    }
    if (start <= time && time <= end) {
      return 0;
    }
    return end <= time ? Number.MAX_VALUE : end - time;
  }

  _findDetail(): IRibbon2Detail | undefined {
    const asset = this.dataSource.asset;
    if (this._matches(this.schedule, asset.asset)) {
      return asset.asset;
    }
    if (this.schedule && this.dataSource.pageProperties.includes(CmsProperty.UseBestSchedule)) {
      // copy the asset first and the override to get as much data as possible, Like minimum Age
      return {
        ...asset.asset,
        ...asset.resources?.find(res => this._matches(this.schedule, res)),
      };
    }
    return asset.asset;
  }

  _matches(schedule: IRibbon2Schedule | undefined, detail: IRibbon2Detail) {
    if (!schedule || !schedule.programId) {
      return false;
    }
    return detail.type === AssetType.PROGRAM && schedule.programId === detail.id;
  }
}
